import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <div style={{ position: 'fixed', bottom: '20px', left: '50%', transform: 'translateX(-50%)', textAlign: 'center', zIndex: 9999 }}>
      <Link to="/privacy-policy" style={{ fontSize: '0.9em', color: '#888', textDecoration: 'underline', marginRight: '20px' }}>
        Privacy Policy
      </Link>
      <Link to="/terms-of-use" style={{ fontSize: '0.9em', color: '#888', textDecoration: 'underline' }}>
        Terms of Use
      </Link>
    </div>
  );
};

export default Footer;